'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Logo = require('../../components/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishHeader = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = function (_React$Component) {
  (0, _inherits3.default)(FlourishHeader, _React$Component);

  function FlourishHeader() {
    (0, _classCallCheck3.default)(this, FlourishHeader);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishHeader.__proto__ || (0, _getPrototypeOf2.default)(FlourishHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          config = _props.config;
      var store = config.store;
      var code = store.code,
          siteName = store.siteName;

      var akzoLogo = require('./assets/' + config.theme + '/akzonobel.svg');
      var lng = this.props.params.lng;

      return _react2.default.createElement(
        'div',
        { styleName: 'o-header' },
        _react2.default.createElement(
          'div',
          { styleName: 'akzoHeader', className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://www.akzonobel.com' },
                _react2.default.createElement('img', {
                  srcSet: akzoLogo,
                  alt: t('akzonobel'),
                  className: 'pull-right',
                  styleName: 'a-akzonobelLogo'
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'header',
          { className: 'row', styleName: 'flourishHeader' },
          _react2.default.createElement(
            'div',
            { className: 'container', style: { position: 'relative' } },
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(
                'a',
                { href: (0, _localisedPaths.localisedRoot)(store, lng) },
                _react2.default.createElement(_Logo2.default, { siteCode: code, alt: siteName })
              )
            ),
            _react2.default.createElement(_Icon2.default, { type: 'padlock' })
          )
        )
      );
    }
  }]);
  return FlourishHeader;
}(_react2.default.Component)) || _class) || _class) || _class);
exports.default = FlourishHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/flourish.js
// module id = 2294
// module chunks = 0